<div class="four_zero_four_page">
    <div class="page_wrap_sections">
        <div class="left_side_secitons">
            <div class="circle_sections">
                <h2>404</h2>
                <p>Page Not Found</p>
            </div>
        </div>
        <div class="right_side_secitons">
            <h2>Oh no!</h2>
            <h3>웹 페이지를 찾을 수 없습니다.</h3>
            <p> 이 페이지에 액세스할 수 없는 경우 입력된 링크가 정확한지 다시 한번 확인 바랍니다. </p>
            <button [routerLink]="['/']">돌아가기 </button> 
        </div>
    </div>
</div>
